import axios from "axios";
import AudioCubeApiCallerInstance from "../utils/AudioCubeApiCallerInstance";
import { SOUNDBOX_API_ENDPOINTS } from "../URLConstants";

export const GetSounBoxAppSettings=()=>{
    const response =  AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS.APP_SETTINGS)
    return response;
}

export const GetTerritoryStructure=(organizationId)=>{
    const response =  AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS.TERRITORIES_STRUCTURE.replace("<orgId>",organizationId))
    return response;
    
}

export const getPinCodeDetails=async(pincode)=>{
    const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`)
    return response;
}